<section class="quote-doc">
  <header class="quote-doc__head">
    <div class="quote-doc__brand">
      <div class="quote-doc__logo">MS</div>
      <div>
        <h3>{{ businessName }}</h3>
        <p>NIT {{ businessNit }}</p>
        <h2>Cotización de servicios</h2>
      </div>
    </div>

    <div class="quote-doc__meta">
      <p><strong>Fecha:</strong> {{ data.createdAt | date: 'dd/MM/yyyy' }}</p>
      <p><strong>Placa:</strong> {{ data.vehicle.plate || '-' }}</p>
      <p>
        <strong>Cotizaciones:</strong>
        {{ quotes.length }}
      </p>
    </div>
  </header>

  <section class="quote-doc__client">
    <article>
      <span>Cliente</span>
      <strong>{{ data.vehicle.customer.name || 'Cliente' }}</strong>
    </article>
    <article>
      <span>Kilometraje</span>
      <strong>{{ data.currentKm | number: '1.0-0' }} km</strong>
    </article>
    <article>
      <span>Total aprobado</span>
      <strong>{{ data.totalApproved | currency: 'COP':'symbol':'1.0-0':'es-CO' }}</strong>
    </article>
  </section>

  @if (quotes.length === 0) {
    <section class="quote-doc__services">
      <p>No hay cotizaciones registradas para este vehículo.</p>
    </section>
  } @else {
    @for (quote of quotes; track quote.id) {
      <section class="quote-doc__quote">
        <header class="quote-doc__quote-head">
          <h4>Cotización v{{ quote.version }}</h4>
          <span class="quote-doc__quote-status">{{ quoteStatusLabel(quote.status) }}</span>
        </header>

        <section class="quote-doc__status-grid">
          <article>
            <span>Items aprobados</span>
            <strong>{{ approvedCount(quote) }}</strong>
          </article>
          <article>
            <span>Items rechazados</span>
            <strong>{{ rejectedCount(quote) }}</strong>
          </article>
          <article>
            <span>Items pendientes</span>
            <strong>{{ pendingCount(quote) }}</strong>
          </article>
        </section>

        <section class="quote-doc__services">
          <div class="quote-doc__services-head">
            <h4>Servicios cotizados</h4>
          </div>

          @if (quote.items.length === 0) {
            <p>No hay servicios registrados en esta cotización.</p>
          } @else {
            <ul>
              @for (item of quote.items; track $index) {
                <li>
                  <span>{{ item.serviceName }}</span>
                  <strong>{{ item.price | currency: 'COP':'symbol':'1.0-0':'es-CO' }}</strong>
                </li>
              }
            </ul>
          }

          <div class="quote-doc__services-total">
            <span>Total cotizado</span>
            <strong>{{ quotedTotal(quote) | currency: 'COP':'symbol':'1.0-0':'es-CO' }}</strong>
          </div>
          <div class="quote-doc__services-total quote-doc__services-total--approved">
            <span>Total aprobado</span>
            <strong>{{ quote.approvedTotal | currency: 'COP':'symbol':'1.0-0':'es-CO' }}</strong>
          </div>
        </section>
      </section>
    }
  }

  <footer class="quote-doc__notes">
    <h4>Condiciones comerciales</h4>
    <ul>
      <li>Los valores pueden ajustarse si se encuentran novedades al desmontar.</li>
      <li>La cotización mantiene vigencia por 15 días hábiles.</li>
      <li>Los tiempos de ejecucion dependen de disponibilidad de repuestos.</li>
      <li>Nosotros no recibimos repuestos de terceros.</li>
    </ul>
  </footer>
</section>


